/*

Server.js

File handles any sort of server call to our server



*/
// local | develop | prod
process.env.ENVIRONMENT = 'prod';

if (process.env.ENVIRONMENT == 'prod') {
	process.env.LIBERTY_MUTUAL_PAYMENT_URL = 'https://rpama-ext.libertymutual.com/';
	process.env.LIBERTY_ORIGIN = 'https://rpama-ext.libertymutual.com';
	process.env.APPLICATION_URL = 'https://api.leasey.co/v1/api/';
	process.env.STRIPE_KEY = 'pk_live_51HXWxYC1xc8b2uX0eIiIK4pqHAezGqsIKlPIba7kiRquyRgLAFOBFR2xUQxaEJ5EdNW1wFSQcLnmSSZZa3cnqsaY00Hnlf49Zm';
} else if (process.env.ENVIRONMENT == 'develop') {
	process.env.LIBERTY_MUTUAL_PAYMENT_URL = 'https://qa-rpama-ext.libertymutual.com?debug=1';
	process.env.LIBERTY_ORIGIN = 'https://qa-rpama-ext.libertymutual.com';
	process.env.APPLICATION_URL = 'https://dev.api.leasey.co/v1/api/';
	process.env.STRIPE_KEY = 'pk_test_51HXWxYC1xc8b2uX0INSIwBIo4r8g6ifCQSfwWUk16iNmgt31mbxMUO03Be8JeT124m3p8oUUYNuapHnjLx13DuPf00qUMlSPlg';
} else {
	process.env.LIBERTY_MUTUAL_PAYMENT_URL = 'http://localhost:8585?debug=1';
	process.env.LIBERTY_ORIGIN = 'http://localhost:8585';
	process.env.APPLICATION_URL = 'http://localhost/v1/api/';
	process.env.STRIPE_KEY = 'pk_test_51HXWxYC1xc8b2uX0INSIwBIo4r8g6ifCQSfwWUk16iNmgt31mbxMUO03Be8JeT124m3p8oUUYNuapHnjLx13DuPf00qUMlSPlg';
}
var Server = Class.create({
  	initialize: function() {
  		// #  Set our key to be passed for validation to our server
  		var secret = "bd7d1aa4-3450-0948-t1f1-b4f6b5a51c9";
  		// #  Store secret locally
  		this.secret = secret;
	},
	getData: function(url,params,async, method = "GET", overrideRoute = false) {
		// #  Add additional secret key for params for authentication
		if(params) {
			params.secret = this.secret;
		}

		// #  Send to our server
		return jQuery.ajax({
			url: overrideRoute ? url: process.env.APPLICATION_URL + url,
		  	method: method,
		  	async: async,
		  	dataType: "json",
			data: params,
			xhrFields: {
				withCredentials: true
			},
			// crossDomain: true,
		  	success:function(response) {
		  	},
		  	error: function(e) {
		  	}
		});
	},
	getFile: function(url,params,async, callback, method = "POST") {
		var request = new XMLHttpRequest();
		request.open(method, process.env.APPLICATION_URL + url, true);
		request.withCredentials = true;
		request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
		request.responseType = 'blob';
		request.onload = function() {
			// Only handle status code 200
			if(request.status === 200) {
				var filename = "default.pdf";
				// Try to find out the filename from the content disposition `filename` value
				var disposition = request.getResponseHeader('Content-Disposition');
				if (disposition) {
					var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
					var matches = filenameRegex.exec(disposition);
					if (matches !== null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                }
				// The actual download
				var blob = new Blob([request.response], { type: 'application/pdf' });
				var link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = filename;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				callback(true);
			} else {
				callback(false);
			}
		};
		if (params != null) {
			request.send(JSON.stringify(params));
		} else {
			request.send();
		}
	}
});

jQuery(document).on({
    ajaxStart: function () {
		jQuery('.requestLoader').delay(1000).queue(function() {
			jQuery(this).addClass('loading').dequeue();
		});
    },
    ajaxStop: function () {
        jQuery('.requestLoader').clearQueue().removeClass('loading');
    }
});

export let server = new Server();



// WEBPACK FOOTER //
// app/core/engine/server.js